// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CircleLoader_wrapper","loader":"CircleLoader_loader","spin":"CircleLoader_spin","slide":"CircleLoader_slide","flash":"CircleLoader_flash"};